// @ts-nocheck
import { Component } from 'react';
import { OperationVariables } from '@apollo/client';
import { MutationFunction } from '@apollo/client';

import 'jquery-ui/themes/base/all.css';
import SurveyCustomWidgets from './survey/widgets';
import { Loader } from '.';

type Props = {
  data?: any;
  questions?: any;
  onAfterRenderQuestion?: any;
  onComplete?: any;
  mutation: MutationFunction<any, OperationVariables>;
  templateId?: string;
};

// window.SurveyCreator.StylesManager.applyTheme('modern');
window.SurveyCreator.StylesManager.applyTheme('defaultV2');

window.Survey.Serializer.addProperties('survey', [
  {
    name: 'pdfOrientation',
    category: 'PDF',
    default: 'auto',
    choices: ['auto', 'portrait', 'landscape'],
    isSerializable: false,
  },
  {
    name: 'pdfFormatType',
    category: 'PDF',
    default: 'default',
    choices: [
      'custom',
      'default',
      'a0',
      'a1',
      'a2',
      'a3',
      'a4',
      'a5',
      'a6',
      'a7',
      'a8',
      'a9',
      'a10',
      'b0',
      'b1',
      'b2',
      'b3',
      'b4',
      'b5',
      'b6',
      'b7',
      'b8',
      'b9',
      'b10',
      'c0',
      'c1',
      'c2',
      'c3',
      'c4',
      'c5',
      'c6',
      'c7',
      'c8',
      'c9',
      'c10',
      'dl',
      'letter',
      'government-letter',
      'legal',
      'junior-legal',
      'ledger',
      'tabloid',
      'credit-card',
    ],
    isSerializable: false,
  },
  {
    name: 'pdfFormatWidth:number',
    category: 'PDF',
    default: 210.0,
    dependsOn: 'pdfFormatType',
    visibleIf: (obj: any) => obj.pdfFormatType === 'custom',
    isSerializable: false,
  },
  {
    name: 'pdfFormatHeight:number',
    category: 'PDF',
    default: 297.0,
    dependsOn: 'pdfFormatType',
    visibleIf: (obj: any) => obj.pdfFormatType === 'custom',
    isSerializable: false,
  },
  {
    name: 'pdfFontSize:number',
    category: 'PDF',
    default: window.SurveyPDF.DocOptions.FONT_SIZE,
    isSerializable: false,
  },
  {
    name: 'pdfFontName:string',
    category: 'PDF',
    default: 'segoe',
    isSerializable: false,
  },
  {
    name: 'pdfMarginTop:number',
    category: 'PDF',
    default: 10.0,
    isSerializable: false,
  },
  {
    name: 'pdfMarginBottom:number',
    category: 'PDF',
    default: 10.0,
    isSerializable: false,
  },
  {
    name: 'pdfMarginLeft:number',
    category: 'PDF',
    default: 10.0,
    isSerializable: false,
  },
  {
    name: 'pdfMarginRight:number',
    category: 'PDF',
    default: 10.0,
    isSerializable: false,
  },
  {
    name: 'pdfHtmlRenderAs',
    category: 'PDF',
    default: 'auto',
    choices: ['auto', 'standard', 'image'],
    isSerializable: false,
  },
  {
    name: 'pdfMatrixRenderAs',
    category: 'PDF',
    default: 'auto',
    choices: ['auto', 'list'],
    isSerializable: false,
  },
  {
    name: 'pdfCompress:boolean',
    category: 'PDF',
    default: false,
    isSerializable: false,
  },
  {
    name: 'pdfMode',
    category: 'PDF',
    default: 'edit',
    choices: ['edit', 'display'],
    isSerializable: false,
  },
  {
    name: 'pdfFileName:string',
    category: 'PDF',
    default: 'survey_result.pdf',
    isSerializable: false,
  },
]);

window.Survey.Serializer.addProperties('question', [
  {
    name: 'requirePhotos',
    category: 'general',
  },
  {
    name: 'category',
    category: 'general',
  },
  {
    name: 'questionNumber',
    category: 'general',
  },
]);

window.SurveyCreator.SurveyQuestionEditorDefinition.definition['question'].properties = [
  'title',
  'name',
  {
    name: 'questionNumber',
    title: 'Question Number',
  },
  {
    name: 'requirePhotos',
    // @ts-ignore
    category: 'checks',
  },
  {
    name: 'category',
    title: 'Category',
  },
  {
    name: 'visible',
    // @ts-ignore
    category: 'checks',
  },
  {
    name: 'isRequired',
    // @ts-ignore
    category: 'checks',
  },
  {
    name: 'readOnly',
    // @ts-ignore
    category: 'checks',
  },
];

SurveyCustomWidgets.register(window.Survey);

/**
 * This component is modelled after the SUrvey Creator example here
 * https://surveyjs.io/Examples/Survey-Creator#content-html
 *
 * Also see react example here:
 * https://github.com/surveyjs/surveyjs_react_quickstart/blob/9c337cf697dd7a0869874117ca642b8df184dbe1/src/SurveyCreator.js
 */

class SurveyCreatorComponent extends Component<Props, { loading: boolean }> {
  surveyCreator: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    let options = {
      showLogicTab: true,
      showEmbededSurveyTab: true,
      haveCommercialLicense: true,
    };
    this.surveyCreator = new window.SurveyCreator.SurveyCreator(null, options);
    this.surveyCreator.saveSurveyFunc = this.saveMySurvey;
    this.surveyCreator.rightContainerActiveItem('toolbox');
    this.surveyCreator.render('surveyCreatorContainer');
    this.surveyCreator.JSON = this.props.data;
  }

  render() {
    if (this.surveyCreator && JSON.stringify(this.surveyCreator.JSON) !== JSON.stringify(this.props.data)) {
      this.props.data && delete this.props.data.templateId;
      //this.surveyCreator.JSON = this.props.data;
    }

    return (
      <div style={{ width: '100%' }}>
        {this.state.loading && <Loader />}
        <div id="surveyCreatorContainer" />
      </div>
    );
  }

  saveMySurvey = async () => {
    this.setState({ loading: true });

    await this.props.mutation({
      variables: {
        input: {
          templateId: this.props.templateId === 'create' ? undefined : this.props.templateId,
          jsonData: JSON.stringify(this.surveyCreator.JSON),
        },
      },
    });

    this.setState({ loading: false });
  };
}

export default SurveyCreatorComponent;
